import { dataHooks } from '../../../../../libs/dataHooks';

export const hoverPanelDataHooks = dataHooks<{
  previewLink: {};
  editorLink: {};
  showIconLabel: {};
}>('hover-panel');
